import PhoneInfoComponent from './PhoneInfoContainer'

export default PhoneInfoComponent;